import React, { createContext, ReactNode, useContext } from 'react';

type ToggleState = {
  disabled?: boolean;
  dense?: boolean;
};

type ToggleProviderProps = {
  children: ReactNode;
  disabled?: boolean;
  dense?: boolean;
};

/**
 * A context to manage the state of a togglable form component.
 */
export const ToggleContext = createContext<
  | {
      state: ToggleState;
    }
  | undefined
>(undefined);

/**
 * A provider for the toggle context.
 */
export const ToggleProvider = ({
  children,
  disabled,
  dense,
}: ToggleProviderProps) => {
  const value = { state: { disabled, dense } };
  return (
    <ToggleContext.Provider value={value}>{children}</ToggleContext.Provider>
  );
};

/**
 * Access the current toggle context.
 */
export function useToggle() {
  const context = useContext(ToggleContext);
  if (context === undefined) {
    throw new Error('useToggle must be used within a ToggleProvider');
  }

  return context.state;
}
